module.exports = __webpack_public_path__ + "img/01.0bf7fe40.jpg";